import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { routes, screenDevices } from 'src/enums';
import { IShortClient } from './services/clients';

export type TAppSlice = {
  clientProfile: IShortClient | undefined;
  isMobile: boolean;
  screenSize: number;
  applicationFormChanged: boolean;
  isNotificationPanelOpen: boolean;
  isSnackbarOpen: boolean;
  isModalOpen: boolean;
  isChangesUnsaved: boolean;
  componentPath: string;
  currentTab: string;
  startRoutePath: string;
  selectedTheme: 'dark' | 'white';
};

const initialState: TAppSlice = {
  clientProfile: undefined,
  isMobile: false,
  screenSize: screenDevices.Desktop,
  applicationFormChanged: false,
  isNotificationPanelOpen: false,
  isSnackbarOpen: false,
  isModalOpen: false,
  isChangesUnsaved: false,
  componentPath: '',
  currentTab: routes.profile,
  startRoutePath: routes.system,
  selectedTheme: 'white',
};

const appSlice = createSlice({
  name: 'appSlice',
  initialState,
  reducers: {
    setClientProfile(state, action: PayloadAction<IShortClient | undefined>) {
      state.clientProfile = action.payload;
    },

    setSelectedTheme(state, action: PayloadAction<TAppSlice['selectedTheme']>) {
      state.selectedTheme = action.payload;
    },

    setIsMobile(state, action: PayloadAction<boolean>) {
      state.isMobile = action.payload;
    },

    setScreenSize(state, action: PayloadAction<number>) {
      state.screenSize = action.payload;
    },

    setApplicationFormChanged(state, action: PayloadAction<boolean>) {
      state.applicationFormChanged = action.payload;
    },

    setIsNotificationPanelOpen(state, action: PayloadAction<boolean>) {
      state.isNotificationPanelOpen = action.payload;
    },

    setIsSnackbarOpen(state, action: PayloadAction<boolean>) {
      state.isSnackbarOpen = action.payload;
    },

    setIsModalOpen(state, action: PayloadAction<boolean>) {
      state.isModalOpen = action.payload;
    },

    setIsChangesUnsaved(state, action: PayloadAction<boolean>) {
      state.isChangesUnsaved = action.payload;
    },

    setComponentPath(state, action: PayloadAction<string>) {
      state.componentPath = action.payload;
    },

    setCurrentTab(state, { payload }: PayloadAction<TAppSlice['currentTab']>) {
      state.currentTab = payload;
    },

    setStartRoutePath(state, { payload }: PayloadAction<TAppSlice['startRoutePath']>) {
      state.startRoutePath = payload;
    },
  },
});

export const {
  setClientProfile,
  setIsMobile,
  setScreenSize,
  setApplicationFormChanged,
  setIsNotificationPanelOpen,
  setIsSnackbarOpen,
  setIsModalOpen,
  setIsChangesUnsaved,
  setComponentPath,
  setCurrentTab,
  setStartRoutePath,
  setSelectedTheme,
} = appSlice.actions;
export default appSlice.reducer;
